import { paymentActionTypes, userActionTypes } from '../actions/types';
import { paymentService } from '../services';
export const paymentActions = {
    report,
};

const isExpiredTokenError = error => (
    error
    && (
        error.code === 'invalidToken'
        || error.name === 'TokenExpiredError'
        || error.error === 'jwt expired'
    )
);

function report(query) {
    return (dispatch, getState) => {
        dispatch(request());

        return paymentService.getPaymentsReport(query).then(
            payments => {
                dispatch(success(payments))
            },
            error => dispatch(failure(error, getState().authentication.pendingRefreshingToken)),
        );
    };

    function request() {
        return { type: paymentActionTypes.REPORT_REQUEST };
    }
    function success(payments) {
        return { type: paymentActionTypes.REPORT_SUCCESS, payments };
    }
    function failure(error, pendingRefreshToken) {
        if (isExpiredTokenError(error)) {
            if (pendingRefreshToken) {
                return {
                    type: userActionTypes.PENDING_REFRESH_TOKEN,
                    error: error.error,
                };
            } else {
                return { type: userActionTypes.INVALID_TOKEN, error: error.error };
            }
        } else {
            return {
                type: paymentActionTypes.REPORT_FAILURE,
                error: (error && (error.error || error.message)) || 'Payment request failed',
            };
        }
    }
}
